
import Vue, { PropType } from "vue";
import LabProductChoice from "../../components/LabProductChoice.vue";

export default Vue.extend({
  name: "ChooseLabProduct",
  methods: {},
  components: { LabProductChoice },
});
